import { useRef, useState } from 'react';

export interface DropzoneProps {
  onSelect: (file: File) => void;
  disabled?: boolean;
  hint?: string;
}

export function Dropzone({ onSelect, disabled, hint }: DropzoneProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [dragging, setDragging] = useState(false);
  const [dragDepth, setDragDepth] = useState(0);

  function accept(files: FileList | null) {
    const file = files?.[0];
    if (file) onSelect(file);
  }

  return (
    <div
      className="dropzone"
      data-drag={dragging}
      onDragEnter={(event) => {
        event.preventDefault();
        setDragDepth((depth) => {
          const next = depth + 1;
          setDragging(next > 0);
          return next;
        });
      }}
      onDragOver={(event) => event.preventDefault()}
      onDragLeave={(event) => {
        event.preventDefault();
        setDragDepth((depth) => {
          const next = Math.max(0, depth - 1);
          setDragging(next > 0);
          return next;
        });
      }}
      onDrop={(event) => {
        event.preventDefault();
        setDragDepth(0);
        setDragging(false);
        if (disabled) return;
        accept(event.dataTransfer?.files ?? null);
      }}
    >
      <span className="icon" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 16V4" />
          <path d="m7 9 5-5 5 5" />
          <path d="M5 20h14" />
        </svg>
      </span>
      <div className="title">拖拽文件到此处，或选择文件</div>
      <div className="hint">{hint ?? '支持图片、文本与结构化文档；源文件不会离开你的设备'}</div>
      <div className="row" style={{ justifyContent: 'center', marginTop: 14 }}>
        <button type="button" className="btn btn-primary" disabled={disabled} onClick={() => inputRef.current?.click()}>
          选择文件
        </button>
      </div>
      <input
        ref={inputRef}
        type="file"
        hidden
        onChange={(event) => {
          accept(event.target.files);
          event.target.value = '';
        }}
      />
    </div>
  );
}
